<script>
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "NumberOfInjuriesIllnesses",
  mixins:[permissionMixin],
  components: {AppLoading},
  data() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);
    return {
      years,
      series: [
        {
          name: 'Injuries',
          data: [],
        },
        {
          name: 'Illnesses',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: false,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (this.isAllowed('menu.reports.accident-incident') === false) {
                return;
              }
              const clickedSeriesIndex = config.seriesIndex;
              const seriesDataIndex = config.dataPointIndex;
              const medicalTypeId = this.series[clickedSeriesIndex].medical_type_id;
              const year = this.years[seriesDataIndex];
              const data = this.injury_and_illnesses.filter(item => {
                return item.id === medicalTypeId;
              })[0].data.filter(item => {
                return item.year === year;
              })[0].values;

              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', true);
              $('#safetyAndHealthModal').modal('show');

              const label = medicalTypeId === 1 ? 'Injuries' : 'Illnesses';
              const data_table = {
                text_header : `Number of ${label} (${year})`,
                safety_and_health_module : 'injury_and_illnesses',
                data : data
              };
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_CHART_DATA', data_table)
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', false);
            }
          }
        },
        title: {
          text: 'NUMBER OF INJURY / ILLNESS',
          align: 'center',
        },
        xaxis: {
          categories: years,
        },
        colors: ['#165d85', '#f36b2a'], // Blue and Orange
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: 'top',
        },
      },
    }
  },
  methods : {
    ...mapActions([
      'getAccidentSafetyAndHealthChartsData',
    ])
  },
  mounted() {
    this.series = this.injury_and_illnesses.map(item => {
      return {
        medical_type_id : item.id,
        name : item.name,
        type : item.type,
        data : item.data.map(yearsData => {
          return yearsData.values.length;
        })
      }
    });
  },
  computed : {
    ...mapGetters([
      'airSafetyAndHealthGraphDataLoading',
      'injury_and_illnesses',
      'cmsRequestedOnBoardCrew',
    ]),
  },
}
</script>

<template>
  <div>
    <div v-if="airSafetyAndHealthGraphDataLoading">
      <app-loading></app-loading>
    </div>
    <div v-else>
      <apexchart
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>

  </div>
</template>

<style scoped>

</style>
